import { AxiosService } from './';

const changePassword = async (formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'admin/account_settings/password/change',
      isAuthorized: true,
      formData: formData,
    };

    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const updateUserDetails = async (formData) => {
  try {
    let axiosData = {
      method: 'put',
      url: 'admin/account_settings',
      isAuthorized: true,
      formData: formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const generateTwoFactorSecret = async (_formData = {}) => {
  try {
    let _axiosData = {
      method: 'post',
      url: 'admin/account_settings/two_factor/generate',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await AxiosService.hit(_axiosData);
    return response.data;
  } catch (error) {
    return Error(error.message);
  }
};

const update2FAStatus = async (_formData = {}) => {
  try {
    let _axiosData = {
      method: 'put',
      url: 'admin/account_settings/two_factor/change_status',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await AxiosService.hit(_axiosData);
    return response.data;
  } catch (error) {
    return Error(error.message);
  }
};

export {
  changePassword,
  updateUserDetails,
  generateTwoFactorSecret,
  update2FAStatus,
};
